import { render, staticRenderFns } from "./list.vue?vue&type=template&id=68a0c85f&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=68a0c85f&scoped=true&lang=css&"
import style1 from "./list.vue?vue&type=style&index=1&lang=css&"
import style2 from "./list.vue?vue&type=style&index=2&id=68a0c85f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0c85f",
  null
  
)

export default component.exports